import { Link } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import styled from 'styled-components';

import { Flex } from '../../../GlobalComponents/Flex';
import { isCartModalOpenState } from '../../../Header/atoms';
import { ProductImage } from './Component/ProductImage';

export type LayoutProps = {
	name: string;
	id: JSX.Element | string;
	price: JSX.Element | string;
	modifiers: JSX.Element | string;
	productId: string;
};

export const Product: React.FC<LayoutProps> = ({
	name,
	productId,
	id,
	price,
	modifiers
}) => {
	const setIsCartModalOpen = useSetRecoilState(isCartModalOpenState);
	return (
		<Flex
			$flexDirection="row"
			$placeContent="center space-between"
			$alignItems="center"
		>
			<Flex
				$flexDirection="row"
				$placeContent="center flex-start"
				$alignItems="center"
				$columnGap="10px"
			>
				<Link
					to={`/product/edit/${id}`}
					onClick={() => setIsCartModalOpen(false)}
				>
					<ProductImage id={productId} name={name}></ProductImage>
				</Link>

				<Flex $flexDirection="column">
					<Link
						to={`/product/edit/${id}`}
						onClick={() => setIsCartModalOpen(false)}
					>
						<ProductName>{name}</ProductName>
					</Link>

					<ProductModifiers>{modifiers}</ProductModifiers>
				</Flex>
			</Flex>

			<ProductPrice>${price}</ProductPrice>
		</Flex>
	);
};

const ProductName = styled.div`
	font-weight: 500;
	font-size: 18px;
	color: #575757;
`;

const ProductModifiers = styled.div`
	font-weight: 400;
	font-size: 16px;
	color: #575757;
`;

const ProductPrice = styled(Flex)`
	font-weight: 400;
	font-size: 24px;
	color: #575757;
	justify-content: flex-end;
`;
